<template>
  <main>
    <section>
      <header class="section-header background-yellow">
        <h1>From the Winery's Cellar to Your Own, Guaranteed</h1>
      </header>
    </section>
    <section class="generic">
      <p>
        It often seems like wine tastes better at the winery where it was made.
        Part of this is the excitement of enjoying a wine in the place where it
        is made, sitting amongst the vines or next to the barrels in which it
        was aged, but there's a tangible reason for this, too.
      </p>
      <p>
        Because they have never been transported from their place of origin,
        wines that come straight from a winery's cellar are in pristine
        condition&mdash;and at Wine Access, it's our top priority to make sure
        they stay that way until they arrive at your door.
      </p>
      <p>
        There are many threats that the shipping process brings to wine, from
        flavor-damaging exposure to light and heat, to the possibility that the
        wine in the bottle isn't actually the wine on the label. It's easy to
        turn a blind eye to the importance of top-quality shipping practices,
        and most retailers do in order to save time and money. But at Wine
        Access, we know it doesn't matter how remarkable a wine is if it doesn't
        arrive in perfect condition.
      </p>
      <p>
        Every day and with every bottle (no matter the price), we take the extra
        steps necessary to ensure every wine shipped from Wine Access HQ is a
        bottle you can trust 100%.
      </p>
      <p>
        Read on to learn how we protect the integrity of every wine we offer.
      </p>
      <p>
        <strong>Straight from the source.</strong> Our team scours the globe to
        bring the world's best wines from the winery to your door&mdash;and
        that's no exaggeration. Every single Wine Access wine is sourced
        directly from the winery, which means there is no chance for fraud. The
        wine on the label is the wine in the bottle.
      </p>
      <p>
        It sounds simple, but many other retailers rely on the "grey market" to
        source seemingly exceptional bottles and sell them for unbelievably low
        prices&mdash;and there's no guarantee that these wines are actually what
        they purport to be. Without the Wine Access direct-sourcing guarantee,
        if it seems too good to be true, it probably is.
      </p>
      <p>
        <strong>Guarded in our cellars.</strong> From the winery, all wines are
        transferred to our cellars, which means that we control the conditions
        in which the wines move. The more times a wine changes hands between
        cellars and warehouses, the more opportunities there are for exposure to
        light, heat, and ultimately, damage.
      </p>
      <p>
        We aim to guard these wines in the same way the men and women who make
        them do: by storing all bottles in our climate-controlled cellars until
        it's time to bring them to our members. Unlike bottles that sit on
        sun-baked retail shelves for weeks or months, our cellars also protect
        wines from the sun and ultraviolet light, which can dull a wine's color,
        diminish fruit flavors, and create unpleasant notes of sewage or rotten
        eggs.
      </p>
      <p>
        <strong>Getting the timing right.</strong> It's not just about how we
        ship wines &mdash; it's about when we ship wines, too. Wine is
        incredibly sensitive to temperature, both hot and cold, so we work with
        the seasons, our shipping carriers, and our members to ensure that wines
        are never subjected to aroma- and flavor-damaging heat or temperature
        fluctuations.
      </p>
      <p>
        We do not ship wines over the weekend to avoid the risk of your shipment
        being held in a FedEx or UPS warehouse that is not temperature
        controlled. We also offer the option to hold purchased wines in our
        cellars over the summer, when high temperatures create riskier shipping
        conditions&mdash;though you can always choose to ship your wines
        immediately.
      </p>
      <p>
        <strong>Climate-controlled shipping.</strong> Even after bottles leave
        our cellars, we don't rest until they arrive safely to our members.
        Careful, zip code-by-zip code shipping allows us to check weather
        patterns for heatwaves and cold snaps to ensure wine cases are never
        subjected to extreme temperature environments. As a secondary assurance,
        we make sure an eco-friendly climate-controlled packaging option is
        available to select when temperatures are warm.
      </p>
      <p>
        If these measures make us seem overly protective of our wines, we're OK
        with that because nothing matters more to us than getting top-quality
        wines to our members in pristine condition. Whether the bottle is being
        opened from the winery's cellar or from yours, it should taste exactly
        as the winemaker intended.
      </p>
    </section>
  </main>
</template>
